import React, { useState, useEffect } from "react";
import {
  Container,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  IconButton,
} from "@mui/material";
import { VENDORS_BY_SPARE_ID_LISTING_COLUMNS } from "../../utils/constant";
import RecordNotFound from "../../common/RecordNotFound";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { VendorListingBySpareIdService } from "../../services/SpareSearchService";
import { useLoading } from "../../common/LoadingContext";
import { useNotificationContext } from "../../common/NotificationContext";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const VendorsDetailBySpareId = () => {
  const [vendorsBySpareId, setVendorsBySpareId] = useState([]);
  const [_type, setType] = useState("");
  const [ setDisableDownloadButton] = useState(true);
  const { id } = useParams();
  const sID = id.replace(":id", id);
  const { setLoading } = useLoading();
  const { showNotification } = useNotificationContext();
  const { state } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    getVendorBySpareId(parseInt(sID));
  }, []);

  const goBack = () => {
    navigate("/spare-search");
  };

  const getVendorBySpareId = async (id) => {
    try {
      const requestBody = {
        spareId: id,
        type: state?.type,
      };
      const res = await VendorListingBySpareIdService(requestBody);
      if (res.statusCode == "6") {
        setVendorsBySpareId(res.data.vendorListDetails);
      } else {
        showNotification("Error", res.message, "error");
      }
      if (res.data.length > 0) {
        setDisableDownloadButton(false);
      }
    } catch (err) {
      console.log("error", err);
    } finally {
      // setLoading(false);
    }
  };

  return (
    <>
      <Container maxWidth="lg" sx={{ mt: 7 }}>
        <Grid item xs={8} sx={{ mb: 1 }}>
        </Grid>
        <Grid
          container
          spacing={1}
          sx={{ pl: 1, pr: 3, mt: 1, mb: 0.5 }}
          display="flex"
        >
          <Grid item xs={8}>
            <Typography
              align="left"
              sx={{
                mr: "auto",
                mt: 1 / 2,
                color: "#003f93",       
              }}
              variant="h6"
            >
              <IconButton sx={{ color: "#003f93" }}>
                <ArrowBackIcon onClick={goBack} />
              </IconButton>{" "}
              Spare Details : {state.code}/{state.spareDescription}
            </Typography>
          </Grid>
        </Grid>
        <Grid
          containervdirection="row"
          justifyContent="center"
          alignItems="center"
        >
          <Grid item xs={12} mb={5} sx={{ pl: 1, pr: 1, mt: 2 }}>
            <Paper elevation={3} variant="elevation">
              <TableContainer sx={{ maxHeight: 720 }}>
                <Table
                  sx={{ maxHeight: 720 }}
                  aria-labelledby="tableTitle"
                  size="small"
                >
                  <TableHead>
                    <TableRow key={"1"}>
                      {VENDORS_BY_SPARE_ID_LISTING_COLUMNS.map((column) => (
                        <TableCell
                          className="tableHeader"
                          size="small"
                          variant="head"
                          key={column.id}
                          sx={{ pt: 1.5, pb: 1.5 }}
                          style={{
                            minWidth: column.minWidth,
                            fontWeight: "bold",
                            color: "#003A6B",
                          }}
                        >
                          {column.label}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  {vendorsBySpareId && vendorsBySpareId.length > 0 ? (
                    <TableBody sx={{ mt: 2 }}>
                      {vendorsBySpareId.map((row, index) => {
                        return (
                          <TableRow
                            tabIndex={-1}
                            hover
                            role="checkbox"
                            key={index}
                          >
                            <TableCell size="medium" key={"code"}>
                              {`${row["code"]}` ?? "-"}
                            </TableCell>
                            <TableCell size="medium" key={"name"}>
                              {`${row["name"]}` ?? "-"}
                            </TableCell>
                            <TableCell size="medium" key={"repair"}>
                              {row["repair"] ? "Yes" : "No"}
                            </TableCell>
                            <TableCell size="medium" key={"active"}>
                              {row["active"] ? "Yes" : "No"}
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  ) : (
                    <TableBody>
                      <TableRow>
                        <TableCell colSpan={7}>
                          <RecordNotFound />
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  )}
                </Table>
              </TableContainer>
            </Paper>
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default VendorsDetailBySpareId;
